import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../lib/api';
import { DirectorIdForm } from '../components/bulk/DirectorIdForm';

export default function MyDirectorId() {
  const { rid } = useParams();
  const [view, setView] = useState(undefined);
  useEffect(() => { api.get('/api/portal/director-requests').then((r) => setView(r.data.find((x) => x.recipient_id === rid) || null)).catch(() => setView(null)); }, [rid]);
  return (
    <div className="max-w-xl mx-auto p-4 sm:p-6 space-y-4" data-testid="my-director-id-page">
      <Link to="/requests" className="text-sm underline text-muted-foreground">← Requests &amp; Tasks</Link>
      <h1 className="font-headings text-2xl font-bold">Provide your Director ID</h1>
      {view === undefined && <p className="text-sm text-muted-foreground">Loading…</p>}
      {view === null && <p className="text-sm" data-testid="my-did-not-found">This request isn't open any more – there's nothing for you to do.</p>}
      {view && <div className="rounded-xl border border-border bg-card p-6"><DirectorIdForm view={view} onSubmit={async (b) => (await api.post(`/api/portal/director-requests/${rid}/submit`, b)).data} /></div>}
    </div>
  );
}
